var p = (f, m, r) => new Promise((i, a) => {
  var n = (o) => {
    try {
      l(r.next(o));
    } catch (t) {
      a(t);
    }
  }, d = (o) => {
    try {
      l(r.throw(o));
    } catch (t) {
      a(t);
    }
  }, l = (o) => o.done ? i(o.value) : Promise.resolve(o.value).then(n, d);
  l((r = r.apply(f, m)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import C from "./aiModifyDialog.ce.vue.js";
import { vCopyVueucStylesToShadowDom as y } from "../../utils/vCopyVueucStylesToShadowDom.js";
import { defineComponent as h, useTemplateRef as _, withDirectives as g, openBlock as N, createBlock as v, withCtx as s, createVNode as c } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useShadowRoot as D } from "../../node_modules/.pnpm/@vue_runtime-dom@3.5.18/node_modules/@vue/runtime-dom/dist/runtime-dom.esm-bundler.js";
import { unref as e } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import w from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/common/zhCN.js";
import P from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/locales/date/zhCN.js";
import R from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/config-provider/src/ConfigProvider.js";
import k from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/MessageProvider.js";
import { NDialogProvider as x } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/dialog/src/DialogProvider.js";
const j = /* @__PURE__ */ h({
  __name: "index.ce",
  setup(f, { expose: m }) {
    const r = _("aiModifyDialogRefs");
    let i = null;
    const a = D(), n = {
      common: {
        primaryColor: "#FC9153",
        primaryColorHover: "#FC9153",
        primaryColorPressed: "#FC9153",
        primaryColorSuppl: "#FC9153"
      }
    }, d = (o) => p(this, null, function* () {
      var t;
      return (t = r.value) == null || t.open({
        orderId: o.orderId || "",
        productionOrderContractNo: o.productionOrderContractNo || "",
        category: o.category || "",
        needCheck: o.needCheck || !1
      }), new Promise((u) => {
        i = u;
      });
    }), l = (o) => {
      i && (i(o), i = null);
    };
    return m({ open: d }), (o, t) => g((N(), v(e(R), {
      locale: e(w),
      "date-locale": e(P),
      "theme-overrides": n,
      "style-mount-target": e(a)
    }, {
      default: s(() => [
        c(e(x), null, {
          default: s(() => [
            c(e(k), { to: e(a) }, {
              default: s(() => [
                c(C, {
                  ref_key: "aiModifyDialogRefs",
                  ref: r,
                  onSubmit: l
                }, null, 512)
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["locale", "date-locale", "style-mount-target"])), [
      [e(y), e(a)]
    ]);
  }
});
export {
  j as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-modify-dialog/index.ce.vue2.js
// module id = 1201
// module chunks = 67